import { render, staticRenderFns } from "./InsertImageItem.vue?vue&type=template&id=6bab1df8&"
import script from "./InsertImageItem.vue?vue&type=script&lang=js&"
export * from "./InsertImageItem.vue?vue&type=script&lang=js&"
import style0 from "./InsertImageItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports